const AccountTypeMap: { [key: number]: string } = {
  1: "特店帳號",
  2: "統編帳號",
  3: "群組帳號",
  4: "管理者帳號"
};

const StateMap: { [key: number]: string } = {
  1: "啟用",
  2: "停用"
};

const MarkMap: { [key: number]: string } = {
  1: "Y 是",
  2: "N 否"
};

const CycleMap: { [key: number]: string } = {
  1: "日開",
  2: "週開",
  3: "月開"
};

const TypeMap: { [key: number]: string } = {
  1: "全開",
  2: "半開",
  3: "不開"
};

const BasisMap: { [key: number]: string } = {
  1: "統編",
  2: "特店代號"
};

const QuotaMap: { [key: number]: string } = {
  1: "Y 定額",
  2: "N 一般"
};

const UserHeader: string[] = [
  "編號",
  "帳號類型",
  "特店代號/統編",
  "使用者代號",
  "更新時間",
  "狀態"
];

export const Store = {
  AccountTypeMap,
  StateMap,
  MarkMap,
  TypeMap,
  CycleMap,
  BasisMap,
  QuotaMap,
  UserHeader
};
